<template>
  <div class="father">
    <div class="" style="margin:5px">
      <el-button type="success" @click="createNewCoupon" plain
        >新建优惠卷</el-button
      >
    </div>
    <createCard
      style="margin-top:8px"
      ref="createCardRef"
      v-show="true"
      @closeCreateCard="closeCreateCard"
    >
      <template v-slot:title>
        新建优惠卷
      </template>
      <template v-slot:cardForm>
        <csc ref="cscRef" @createShopCoupon="createShopCoupon"></csc>
      </template>
      <template v-slot:btn_name>
        <el-button
          type="primary"
          plain
          style="margin-left:204px"
          @click="createCoupon"
          >保存
        </el-button>
      </template>
    </createCard>
    <!-- :classList="class_list" -->
    <wtyTemplate
      :who="'createCoupons'"
      :headtemp="'steps'"
      ref="wtyTemplateRef"
      @wtyTemplateReturn="wtyTemplateReturn"
      :classList="classList"
    ></wtyTemplate>
  </div>
</template>
<script>
import { GetCardClassify, testRes, searchWxMCDetail } from "@/api/index";
import csc from "../../components/csc.vue";
import createCard from "@/components/createCard.vue";
import wtyTemplate from "@/components/wty-template.vue";
import { getBusifavorCouponInfo } from "../../js/couponInfo.js";

export default {
  components: {
    createCard,
    csc,
    wtyTemplate
  },
  data() {
    return {
      //["预充值代金卷", "免充值代金卷"]
      //商家卷["满减卷","换购卷","折扣卷"]
      // class_list: ["代金卷", "商家卷"], //传导wty-template里面的数组用来区分卡卷
      classList: ["代金卷", "满减卷", "折扣卷"],
      search_input: "",
      // dialogFormVisible: false,
      height: "height:" + (document.body.clientHeight - 450) + "px",
      activeData: [],
      allCard: []
      // multipleSelection: []
    };
  },
  async mounted() {
    /* console.log(
      "卡卷信息：",
      getBusifavorCouponInfo("normal", "固定面额满减卷", "NORMAL", 5, 50)
    ); */
    /* const a = await searchWxMCDetail("1283560000000005");
    this.getDateStr(); */
  },
  methods: {
    /**
     * //TODO: 返回选中的值 商家卷 和 折扣卷 这两种
     * @param {*} list
     */
    wtyTemplateReturn(data) {
      console.log("选中优惠卷模板");
      this.$refs.createCardRef.openBox();
    },
    /**
     * 创建优惠卷返回
     * @param {*} res 返回
     */
    createShopCoupon(res) {
      this.$refs.createCardRef.closeBox();
    },
    //创建卡卷
    createNewCoupon() {
      //TODO:
      this.$refs.wtyTemplateRef.showDialog();
      // this.$refs.createCardRef.openBox();
    },
    //接口生成卡卷
    createCoupon() {
      this.$refs.cscRef.createCoupon();
    },
    search() {
      let active_list = [];
      const arr = this.allCard;
      for (var x = 0; x < arr.length; x++) {
        if (arr[x].classify_name.indexOf(this.search_input) >= 0) {
          active_list.push(arr[x]);
        }
      }
      this.activeData = [];
      this.activeData = active_list;
    },
    closeCreateCard(res) {
      this.getActive();
    },
    async getActive() {
      return;
      var result = await GetCardClassify();
      testRes(result);
      const {
        data: { resp_data: res }
      } = result;
      this.activeData = res;
      this.allCard = res;
    }
  }
};
</script>
<style scoped>
.father {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 99%;
  background-color: #fff;
  margin: 0px;
  padding: 0px;
}
.el-breadcrumb {
  width: 50%;
  height: 25px;
  margin: 0px;
  padding: 5px 0 0 10px;
}
.card-title {
  height: 50px;
  display: flex;
  justify-content: space-between;
}
.dialog-footer {
  width: 100%;
  text-align: left;
  position: relative;
  left: 0px;
}
.switch-father {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: left;
}
</style>
